export default "__VITE_ASSET__0557e5a3__"